import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";
import { Certame } from "../../sdk/@types";
import CertameService from "../../sdk/services/CertameService";

interface CertameState {
  certame: Certame.Certame | null;
  list: Certame.Certame[];
  fetching: boolean;
}

const initialState: CertameState = {
  certame: null,
  list: [],
  fetching: false,
};

export const getCertames = createAsyncThunk(
  "certame/getCertames",
  async () => await CertameService.getCertames(),
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getCertames);
  const error = isRejected(getCertames);
  const loading = isPending(getCertames);

  builder
    .addCase(getCertames.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
